import {IBrigade, IBrigadeListPayload, IBrigadeStatus} from "../../models/brigade"
import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {IValidationBrigadeFormErrors} from "../../models/validation"
import {AxiosError} from "axios"

interface BrigadeState {
  list: IBrigade[]
  pages: number
  totalCount: number
  pageSize: number
  currentPage: number
  isLoading: boolean
  isCreating: boolean
  isUpdating: boolean
  fetchError: string
  fieldError: any
  employeeGroupError: {
    message?: string,
    uuids?: string[]
  }
  statuses: IBrigadeStatus[]
}

const initialState: BrigadeState = {
  list: [],
  pages: 0,
  totalCount: 0,
  pageSize: 10,
  currentPage: 1,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  fieldError: {},
  fetchError: "",
  employeeGroupError: {
    uuids: []
  },
  statuses: []
}

export const brigadeSlice = createSlice({
  name: 'brigade',
  initialState,
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<IBrigadeListPayload>) {
      state.isLoading = false
      state.fieldError = {}
      state.list = action.payload.list || []
      state.pages = action.payload.pages
      state.totalCount = action.payload.totalCount
    },
    fetchError(state, action: PayloadAction<AxiosError>) {
      state.isLoading = false

      if (action.payload.response?.status === 403) {
        state.fetchError = "У вас нет разрешения на эту операцию!"
      } else {
        state.fetchError = action.payload.message
      }
    },
    creating(state) {
      state.isCreating = true
    },
    createSuccess(state, action: PayloadAction<IBrigade>) {
      state.isCreating = false
    },
    updating(state) {
      state.isUpdating = true
    },
    updateSuccess(state) {
      state.isUpdating = false
    },
    getStatuses(state, action: PayloadAction<IBrigadeStatus[]>) {
      state.statuses = action.payload
    },
    saveError(state, action: PayloadAction<IValidationBrigadeFormErrors>) {
      state.isCreating = false
      state.isUpdating = false

      const fieldErrors = action.payload.field_errors
      const employeeErrors = action.payload.employee_errors

      if (fieldErrors && fieldErrors.length) {
        fieldErrors.forEach(item => {
          state.fieldError[item.field] = item.message
        })
      }

      if (employeeErrors) {
        state.employeeGroupError = employeeErrors
      }
    },
    clearFieldError(state, action: PayloadAction<string>) {
      delete state.fieldError[action.payload]
    },
    clearAllErrors(state) {
      state.fieldError = {}
      state.employeeGroupError = {}
      state.isUpdating = false
      state.isCreating = false
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload
    }
  }
})

export default brigadeSlice.reducer